module.exports = __webpack_public_path__ + "ionicons.19e65b89cee273a249fb.eot";


//////////////////
// WEBPACK FOOTER
// ./~/ionicons/fonts/ionicons.eot?v=2.0.1
// module id = 195
// module chunks = 2